export const enrollButtonState = (
  isEnrolled: boolean,
  isGraduated: boolean,
  canEnroll: boolean,
  isUniversityProgram: boolean | null
): { disabled: boolean; ctaText: string } => {
  if (isEnrolled) {
    return {
      disabled: true,
      ctaText: 'Currently Enrolled',
    };
  } else if (isGraduated) {
    return {
      disabled: true,
      ctaText: 'Already Graduated',
    };
  } else if (!canEnroll) {
    return {
      disabled: true,
      ctaText: 'Not available',
    };
  }

  return {
    disabled: false,
    ctaText: isUniversityProgram ? 'Apply Now' : 'Enroll Now',
  };
};
